<section>
  <app-custom-rules [poilicyName]="currentPolicyName"> </app-custom-rules>
</section>
